import styled from "@emotion/styled";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import React from 'react'

interface UploadedFileProps {
    file: File;
}

export default function UploadedFile({ file }: UploadedFileProps) {
  return (
    <>
        <StyledPaper>
            <Typography variant="h6">File Name:</Typography>
            <FileName variant="h6">{file.name}</FileName>
        </StyledPaper>
    </>
  )
}

const StyledPaper = styled(Paper)({
    display: "flex",
    flexDirection: "column",
    textAlign: "center",
})

const FileName = styled(Typography)({
    fontWeight: 500,
    opacity: .8,
})
